import readUploadedFile from '../../../utils/readUploadedFile';
import SparkMD5 from 'spark-md5';
export async function extractFileData(file: any) {
  const label = file.name;
  const type = file.type;
  const content = await readUploadedFile(file);
  const md5Content = btoa(SparkMD5.ArrayBuffer.hash(content as ArrayBuffer, true));
  return { label, type, content, md5Content };
}
